<template>
    <div class="fab" @click="handleClick">
        <i class="fa fa-phone opacity-10" ></i>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      handleClick() {
        const phoneNumber = '*777';
        const dialUrl = `tel:${phoneNumber}`;
  
        // Lógica para marcar el número
        window.open(dialUrl, '_blank');
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  i{
    color: #ffffff;
    transform: rotate(90deg);
  }
  .fab {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
    background-color: #043057;
    border-radius: 50%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
    font-size: 16px;
  }
  </style>